import encryptEas from "./components/encryptEas";
import decryptEas from "./components/decryptEas";

const getepayPortal = (data, config,callback) => {
  const JsonData = JSON.stringify(data);

  var ciphertext = encryptEas(
    JsonData,
    config["GetepayKey"],
    config["GetepayIV"]
  );

  var newCipher = ciphertext.toUpperCase();

  var myHeaders = new Headers();

  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    mid: data.mid,
    terminalId: data.terminalId,
    req: newCipher,
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  fetch(config["GetepayUrl"], requestOptions)
    .then((response) => response.text())
    .then((result) => {
      console.log(result);
      var resultobj = JSON.parse(result);
      var responseurl = resultobj.response;
      var dataitem = decryptEas(
        responseurl,
        config["GetepayKey"],
        config["GetepayIV"]
      );

      dataitem = JSON.parse(dataitem);
      console.log("Decrypted response data:", dataitem);
      // Call the callback with the response data
      if (callback) {
        callback({
          status: "success",
          paymentUrl: dataitem.paymentUrl,
          ...dataitem
        });
      }

      window.location.href = dataitem.paymentUrl;
    })
    .catch((error) => {
      console.log("error", error);
      if (callback) {
        callback({ status: "error", error });
      }
    });
};

export default getepayPortal;
